import { useEffect, useState } from "react";

const useElementSize = (inputRef) => {
  const [rect, setRect] = useState(0);

  useEffect(() => {
    const updateDropdownPosition = () => {
      const inputRect = inputRef?.current?.getBoundingClientRect();
      if (!inputRect) return;

      setRect(inputRect);
    };

    updateDropdownPosition();

    window.addEventListener("resize", updateDropdownPosition);

    return () => {
      window.removeEventListener("resize", updateDropdownPosition);
    };
  }, [inputRef?.current]);

  return { width: rect.width, height: rect.height };
};

export default useElementSize;
